import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import { VideoPracticeActivity } from 'redux/schemas/models/video-practice';

import NvIcon from 'shared/components/nv-icon';
import { CheckIcon, todoIcon, todoProgress } from './todo-row';
import TodoThumbnail, { TodoThumbnailProps } from './todo-thumbnail';
import ActivityDeadline from './activity-deadline';

type VideoPracticeTodoProps = VideoPracticeActivity & TodoThumbnailProps;

function VideoPracticeTodo({
  type,
  title,
  deadline,
  progress,
  thumbnailSrc,
  backgroundColor,
}: VideoPracticeTodoProps) {
  const icon = todoIcon[type];
  const deadlineMoment = moment(deadline);
  const currentMoment = moment();

  const isComplete = progress === todoProgress.COMPLETED;

  const showDueSoon = deadline
    && !isComplete
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    isComplete && 'completed',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <TodoThumbnail
          thumbnailSrc={thumbnailSrc}
          backgroundColor={backgroundColor}
        />
        <div className='todo-icon'>
          {isComplete
            ? <CheckIcon />
            : <NvIcon icon={icon} size='smallest' />}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isComplete && t.TIMELINE.EXERCISE_STATUS.COMPLETED()}
        </div>
        <ActivityDeadline deadline={deadline} />
      </div>
    </div>
  );
}

export default VideoPracticeTodo;
